import Form, { formCreate } from '@/found/components/form';
import PhotoRespVos from './photo_list.vue';

formCreate.component('PhotoRespVos', PhotoRespVos);
export default {
  name: 'promote_employee_salaries',
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'promote_employee_form',
    };
  },
  methods: {
    formComplete() {
      if (this.formConfig.code === 'view') {
        const tempData = this.formConfig.row;
        this.setValue(this.formConfig.row);
        if (tempData && tempData.photoRespVos && photoRespVos.length !== 0) {
          this.hiddenFields(false, ['photoRespVos', 'title2']);
        } else {
          this.hiddenFields(true, ['photoRespVos', 'title2']);
        }
      }
    },
    setRule(item) {
      const v = item;
      if (v.field === 'photoRespVos') {
        v.props.value = this.formConfig.row.photoRespVos || [];
      }
      return v;
    },

  },
  created() {

  },

};
